import { Resources, useResource } from "Translations/Resources";
import { useLoyaltiesEventsQuery } from "Api/Queries/Loyalty/useLoyaltiesEventsQuery";
import { useMemo } from "react";
import type { LoyaltyEventDto } from "Infrastructure/Api/Api";
import { Challenges } from "Components/Loyalty/Shared/Challenges/Variants/Challenges";
import {
  eventFilters,
  calculateTimeRemaining,
} from "Components/Loyalty/Shared/Challenges/Categories/utils";
import type { ChallengeVariant } from "Components/Loyalty/Shared/Challenges/Categories/types";
import { formatRemainingRelativeTime } from "Utils/TimeUtils";

const RESOURCES = Resources.Pages.Content.Loyalty.Challenges;

type Props = {
  variant?: ChallengeVariant;
};

export const MonthlyChallenges = ({ variant = "card" }: Props) => {
  const { data, isLoading } = useLoyaltiesEventsQuery();
  const { t } = useResource();

  const monthlyEvents = useMemo<Array<LoyaltyEventDto>>(() => {
    if (!data?.events) {
      return [];
    }
    return data.events.filter(eventFilters.monthly);
  }, [data]);

  const { days, hours } = calculateTimeRemaining(monthlyEvents[0]?.resetsAt); // all monthly events reset at the same time, so i take first one
  const timeRemaining =
    days || hours
      ? `${t(Resources.Common.Restart)}: ${formatRemainingRelativeTime({ days, hours }, t)}`
      : undefined;

  return (
    <Challenges
      challenges={monthlyEvents}
      title={t(RESOURCES.MonthlyChallenges.Title)}
      isLoading={isLoading}
      variant={variant}
      timeRemaining={timeRemaining}
    />
  );
};
